"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var SvgUtils = require("./svg-utils");
var _1 = require("../util/_");
var vdl_prefix_1 = require("../util/vdl-prefix");
var SIZE = {
    'sm': { size: 40, borderWidth: 2, minFontSize: 12, maxFontSize: 20 },
    'md': { size: 70, borderWidth: 4, minFontSize: 18, maxFontSize: 30 },
    'lg': { size: 100, borderWidth: 5, minFontSize: 24, maxFontSize: 40 },
    'xl': { size: 125, borderWidth: 5, minFontSize: 30, maxFontSize: 50 }
};
var DataCoin = /** @class */ (function (_super) {
    __extends(DataCoin, _super);
    function DataCoin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            percentage: 0 // starting value for animation
        };
        _this._isMounted = false;
        _this.animate = function () {
            if (!_this.props.duration || !_this._animationStart || _this.state.percentage === _this.props.percentage || !_this._isMounted) {
                return;
            }
            var animationProgress = (Date.now() - _this._animationStart) / _this.props.duration;
            _this.setState({
                percentage: (animationProgress >= (_this.props.percentage || 0) ? _this.props.percentage : animationProgress)
            });
            // We need to rerender when state doesn't change
            _this.forceUpdate();
        };
        _this.resizeText = function () {
            if (_this._fontSize) {
                return;
            }
            var dataCoinSize = SIZE[_this.props.size];
            var maxSize = dataCoinSize.size - dataCoinSize.borderWidth * 6;
            var descriptionHeight = ReactDOM.findDOMNode(_this._description).offsetHeight;
            var valueNode = ReactDOM.findDOMNode(_this._value);
            // using binary search to find the max font size for which the text still fits inside the poker chip
            var min = dataCoinSize.minFontSize;
            var max = dataCoinSize.maxFontSize;
            _this._fontSize = valueNode.style.fontSize ? parseInt(valueNode.style.fontSize) : Math.ceil((min + max) / 2);
            if (_this._fontSize < min) {
                _this._fontSize = min;
            }
            else if (_this._fontSize > max) {
                _this._fontSize = max;
            }
            while (min < max) {
                valueNode.style.fontSize = (_this._fontSize + 'px');
                if (valueNode.offsetWidth < maxSize && valueNode.offsetHeight + descriptionHeight < maxSize) {
                    min = _this._fontSize;
                }
                else {
                    max = (_this._fontSize || 0) - 1;
                }
                _this._fontSize = Math.ceil((min + max) / 2);
            }
        };
        _this.renderFullArc = function (cx, cy, radius, borderWidth, className) {
            var d = [
                SvgUtils.moveTo(cx, 0),
                SvgUtils.circleArc(radius, cx, cy, true),
                SvgUtils.moveTo(cx, borderWidth),
                SvgUtils.circleArc(radius - borderWidth, cx, cy, false),
                'Z'
            ].join('');
            return (React.createElement("path", { className: className, d: d }));
        };
        _this.renderPercentageArc = function (percentage, cx, cy, radius, borderWidth, className) {
            if (percentage > 0.99999) {
                percentage = 0.99999;
            }
            else if (percentage <= 0) {
                return;
            }
            var angle = percentage * 2 * Math.PI;
            var sine = Math.sin(angle);
            var cosine = Math.cos(angle);
            var largeArc = percentage >= 0.5;
            var d = [
                SvgUtils.moveTo(cx, 0),
                SvgUtils.arc(radius, radius, cx + radius * sine, cy - radius * cosine, largeArc, true),
                SvgUtils.lineTo(cx + (radius - borderWidth) * sine, cy - (radius - borderWidth) * cosine),
                SvgUtils.arc(radius - borderWidth, radius - borderWidth, cx, borderWidth, largeArc, false),
                'Z'
            ].join('');
            return (React.createElement("path", { className: className, d: d }));
        };
        return _this;
    }
    DataCoin.prototype.componentDidMount = function () {
        var _this = this;
        this._isMounted = true;
        this.resizeText();
        setTimeout(function () {
            _this._animationStart = Date.now();
            _this._request = requestAnimationFrame(_this.animate);
        }, this.props.delay);
    };
    DataCoin.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.percentage !== this.props.percentage) {
            this._animationStart = Date.now();
        }
        this._fontSize = null; // enables resizeText()
    };
    DataCoin.prototype.componentDidUpdate = function () {
        if (this._request) {
            cancelAnimationFrame(this._request);
        }
        this._request = requestAnimationFrame(this.animate);
        this.resizeText();
    };
    DataCoin.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        if (this._request) {
            cancelAnimationFrame(this._request);
        }
    };
    DataCoin.prototype.render = function () {
        var _this = this;
        var size = SIZE[this.props.size].size, borderWidth = SIZE[this.props.size].borderWidth, radius = size / 2, cx = size / 2, cy = cx;
        var otherProps = _1.omit(this.props, Object.keys(DataCoin.propTypes));
        var DataCoinClasses = [
            vdl_prefix_1.vdlPrefix('data-coin'),
            vdl_prefix_1.vdlPrefix("data-coin--" + this.props.size)
        ];
        var DataCoinContentClasses = [
            vdl_prefix_1.vdlPrefix('data-coin__content'),
            vdl_prefix_1.vdlPrefix("data-coin__content--" + this.props.size)
        ];
        var DataCoinRingClasses = [
            vdl_prefix_1.vdlPrefix('data-coin__ring'),
            vdl_prefix_1.vdlPrefix("data-coin__ring--" + this.props.size)
        ];
        var DataCoinValueClasses = [
            vdl_prefix_1.vdlPrefix('data-coin__value'),
            vdl_prefix_1.vdlPrefix("data-coin__value--" + this.props.size)
        ];
        var DataCoinDescriptionClasses = [
            vdl_prefix_1.vdlPrefix('data-coin__description'),
            vdl_prefix_1.vdlPrefix("data-coin__description--" + this.props.size)
        ];
        //FIXME when react typings include all SVG attributes add
        // shapeRendering="optimizeQuality" to svg
        return (React.createElement("div", __assign({}, otherProps, { className: classnames_1.classNames(this.props.className, DataCoinClasses), style: this.props.style }),
            React.createElement("svg", { className: classnames_1.classNames(DataCoinRingClasses) },
                this.renderFullArc(cx, cy, radius, borderWidth, vdl_prefix_1.vdlPrefix('data-coin__ring__background')),
                this.renderPercentageArc(this.state.percentage, cx, cy, radius, borderWidth, vdl_prefix_1.vdlPrefix('data-coin__ring__percentage'))),
            React.createElement("div", { className: classnames_1.classNames(DataCoinContentClasses) },
                React.createElement("div", { ref: function (c) { _this._value = c; }, className: classnames_1.classNames(DataCoinValueClasses) }, this.props.value),
                React.createElement("div", { ref: function (c) { _this._description = c; }, className: classnames_1.classNames(DataCoinDescriptionClasses) }, this.props.description))));
    };
    DataCoin.propTypes = {
        size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm']),
        percentage: PropTypes.number,
        value: PropTypes.node,
        description: PropTypes.node,
        delay: PropTypes.number,
        duration: PropTypes.number,
        className: PropTypes.string,
        style: PropTypes.object
    };
    DataCoin.defaultProps = {
        size: 'md',
        percentage: 1.0,
        value: '',
        description: '',
        delay: 300,
        duration: 750
    };
    return DataCoin;
}(React.PureComponent));
exports.DataCoin = DataCoin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/data-coin/data-coin.js
// module id = 510
// module chunks = 0 1 2 3 4 5 6